<template>
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.3">
      <rect x="19.8334" y="36.8334" width="8.5" height="14.1667" fill="#151515" />
      <rect x="31.1666" y="28.3334" width="8.5" height="22.6667" fill="#151515" />
      <rect x="42.5" y="19.8334" width="8.5" height="31.1667" fill="#151515" />
    </g>
  </svg>
</template>
